module.exports = __webpack_public_path__ + "img/menu2-1.2eec552f.jpg";